import { inject, injectable, injectFromBase } from 'inversify'
import type { WrapperOpenableInterface } from '@/services/wrappers/types'
import { SERVICE_TYPES } from '@/core/container/types'
import GroupedPartialUIWrapperService from '@/services/wrappers/groupedPartialUIWrapperService'

@injectable()
@injectFromBase()
export default class GroupedQueryPartialUIWrapperService extends GroupedPartialUIWrapperService {
  constructor(
    @inject(SERVICE_TYPES.PartialQueryUIWrapperService)
    protected readonly partialUIWrapperService: WrapperOpenableInterface,
  ) {
    super(partialUIWrapperService)
  }
}
